module.exports = __webpack_public_path__ + "img/blog_image_reviews.20df2481.jpg";